import { render, staticRenderFns } from "./AstralCard.vue?vue&type=template&id=2a73f995&scoped=true&"
import script from "./AstralCard.vue?vue&type=script&lang=js&"
export * from "./AstralCard.vue?vue&type=script&lang=js&"
import style0 from "./AstralCard.vue?vue&type=style&index=0&id=2a73f995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73f995",
  null
  
)

export default component.exports